
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/arcade-machines/[arcadeMachineId]",
      function () {
        return require("private-next-pages/arcade-machines/[arcadeMachineId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/arcade-machines/[arcadeMachineId]"])
      });
    }
  